import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../../utility/WindowSizeHooks"
import ItemCardQuickViewModal from "../ItemCardQuickViewModal"
import AddItemToCartModal from "./AddItemToCartModal";
import { Button, Link } from "@mui/material";
import { fetchAPI } from "@/utility/NetworkUtils";
const ItemCard = (props) => {
  const { hold, event, recieved, removeHold = ()=>{}, onClose} = props
  const [item, setItem] = React.useState(props.item)

  useEffect(() => {

    setItem(props.item) 
  }, [item])
  
  const fetchItem = () => {
    fetchAPI(`/webapi/items/${item.id}`, (json) => {
      if (!json.errors) {
        setItem(json)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }
  const renderItemIcons = () => {
    let icons = [];
    if(!item.public){
      icons = icons.concat([
        <img className="item-card-icon" src="/images/internal_view_icon.png"/>
      ])
    }
    return (
      <div className="item-card-icon-area">
        {icons}
      </div>
    )
  }
  

  const renderSize = () => {
    const dimensions = [item.product_width, item.product_height, item.product_length].filter(x=>x).map(x=>parseFloat(x))
    if(dimensions.length > 0) {
      let value = "";
      if(item.size_type) {
        value = dimensions.map(x=>x+'ft.').join(" x ")
      }else {
        value = dimensions.map(x=>x+'"').join(" x ")
      }
      return value
    }
  }

  const size = renderSize()

  const renderSubSizes = () => {
    const size = renderSize()
    if(item.apparel_size || item.apparel_gender){
      return [item.apparel_gender, item.apparel_size] .filter(x=>x).join(", ")
    }else if (size) {
      return size
    }
  }

  const renderHoverButtons = () => {
    if(hold) {
      return (
         <div className="item-card-overlay">
            {!!item.deleted_at ? (
              <Button variant="contained" color="cancel" type="button">Item Deleted</Button>
            ) : (
              <ItemCardQuickViewModal onClose={(
                changes = false
              )=>{
                if(onClose) {
                  onClose( changes )
                }else {
                  window.location.reload();
                }
              }} item={item} {...props}/>
            )}

            {hold.locked ? (
              <Button variant="contained" href={`/events/${event.slug}/item_holds/${hold.id}`} color="burgandy" type="button">View Event Hold</Button>
            ) : (
              <Button variant="contained" href={`/events/${event.slug}/item_holds/${hold.id}`} color="burgandy" type="button">Edit Event Hold</Button>
            )}

            {!hold.locked ? (
              <Button variant="contained" style={{marginTop: "30px"}} onClick={()=>removeHold(hold)} color="burgandy" type="button">Remove Event Hold</Button>
            ) : ""}
         </div>
      )
    }
    return (
      <div className="item-card-overlay">
        <ItemCardQuickViewModal onClose={fetchItem} item={item} {...props}/>
        <Button variant="contained" color="green" href={`/items/${item.id}/`}>Full View </Button>
      </div>
    )
  }


  const renderHoldFlags = () => {
    const jaguar_yellow = "#FDB92A";
    const jaguar_red = "#F00"
    if(!hold) return;
    const flags = [];
    const isOrdered = recieved === false || (item.expected_receiving||0) > 0;
    const isInsufficient = (hold.status == "reserved" || hold.status == "in_progress") && (hold.total_count||0) > (item.owned||0) + (item.expected_receiving||0) && !isOrdered && !item.deleted_at

    if(hold.direct_to_site) {
      flags.push({
        label: "Direct to Site",
        color: jaguar_yellow
      })
    }
    if(hold.dispose_after_event) {
      flags.push({
        label: "Dispose",
        color: jaguar_yellow
      })
    }
    if(hold.not_returning) {
      flags.push({
        label: "Not Returning",
        color: jaguar_yellow
      })
    }
    if(isOrdered) {
      flags.push({
        label: "Ordered",
        color: jaguar_yellow
      })
    }
    if(isInsufficient) {
      flags.push({
        label: "Insufficient",
        color: jaguar_red,
        textColor: "white"
      })
    }
    if(hold.order_not_finalized) {
      flags.push({
        label: "Not Finalized",
        color: jaguar_red,
        textColor: "white"
      })
    }
    if(item.deleted_at) {
      flags.push({
        label: "Item Deleted",
        color: jaguar_red,
        textColor: "white"
      })
    }

    const renderedFlags = [getStatusFlag()].concat(flags).map(flag => {
      return (
        <div className="item-card-flag" style={{background: flag.color, color: flag.textColor||"black"}}>
          {flag.label}
        </div>
      )
    })
    return (
      <div className="item-card-flag-container">
        {renderedFlags}
      </div>
    )
  }

  const renderHoldCount = () => {
    return (
      <div className="item-card-hold-count"
        style={{
          color: getHoldCountColor()
        }}
      >
        {hold.total_count}
        {hold.locked && (
          <img src="/images/Lock.svg"/>
        )}
      </div>
    )
  }

  const getStatusFlag = () => {
     if(event.manifest_return_completed_at && !hold.dispose_after_event && !hold.not_returning) {
      return {
        label: "Finalized",
        color: "#0B7"
      }
    }
    switch(hold.status) {
      case "reserved":
        return {
          label: "Reserved",
          color: "#D9D9D9",
          textColor: "black"
        }
      case "in_progress":
        return {
          label: "In Progress",
          color: "rgba(230, 0, 115, 0.35)"
        }
      case "packed":
        return {
          label: "Packed",
          color: "#E60073",
          textColor: "white"
        }
      case "shipped":
        return {
          label: "Shipped",
          color: "#3070E7",
          textColor: "white"
        }
      case "received":
        return {
          label: "Checked In",
          color: "#00452C",
          textColor: "white"
        }
      default:
        return null
    }
  }

  const getHoldCountColor = () => {
    if(event.manifest_return_completed_at) {
      return "#0B7"
    }
    switch(hold.status) {
      case "reserved":
        return "black"
      case "in_progress":
        return "#E60073"
      case "packed":
        return  "#E60073"
      case "shipped":
        return "#3070E7"
      case "received":
        return "#00452C"
      default:
        return "black"
    }
  }
  return (
    <div className={`item-card ${hold ? "hold-item-card" : ""}`}>
      {renderItemIcons()}
      {renderHoverButtons()}
      {renderHoldFlags()}
       {hold && renderHoldCount()} 
      <div
        className="item-card-image"
        style={{backgroundImage: `url("${item.active_image ? item.active_image.thumbnail_url : ""}")`}}
      >
    
      </div>
      <div className="item-card-description">
        <a href={`/items/${item.id}`}>
          <div className="name-outer">
            <div className="name">
              {item.name} 
            </div>
         
          </div>
          <div className="additional-details">
            
            <div className="card-field category">
              {item?.category?.group_name}, {item?.category?.name}
            </div>
            <div className="card-field category">
             {renderSubSizes()}
            </div>

          </div>
          {!hold && <div className="owned font-bold"> Qty. {item.currently_available||0}/{item.owned||0} </div>}
        </a>
      </div>
    </div>
  )
}

ItemCard.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ItemCard;
